// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2VO4d","content":"Consent_content__13c2g","footer":"Consent_footer__2Z12h"};